import { useEffect } from 'react';
import { setDownloadManagerInfo } from 'actions/app_action';
import { ReactQueryKeys } from 'common/enums';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { useQuery, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { exportsRequestConfig } from 'request-config/exports/exports.request-config';

export const useFileExportsCounter = () => {
  const userId = useTypedSelector(state => state['app'].user.id);
  const dispatch = useDispatch();
  const { newFiles, totalFiles, filesInProgress } = useTypedSelector(state => state['app'].downloadManager);
  const isExportsFlowExist = useTypedSelector(state => state['app'].isExportsFlowExist);
  const queryClient = useQueryClient();

  const { fetch: getFilesCounter } = useFetch({
    loadingKey: 'getFilesCounter',
    ...exportsRequestConfig.getFilesCounter(userId),
    isShowLoading: false
  });

  const { data } = useQuery([ReactQueryKeys.DownloadManageCounter], getFilesCounter, {
    refetchInterval: 30000,
    select: response => response.data.data,
    enabled: Boolean(isExportsFlowExist && userId),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true
  });

  useEffect(() => {
    if (data && isExportsFlowExist) {
      const isCountersExist = newFiles && totalFiles;
      const isFilesUpdated = data.new !== newFiles || data.total !== totalFiles || data.inProgress !== filesInProgress;

      const refetchList = isCountersExist && isFilesUpdated;

      if (refetchList) {
        queryClient.refetchQueries([ReactQueryKeys.DownloadManagerFiles]);
      }

      dispatch(
        setDownloadManagerInfo({ newFiles: data.new, totalFiles: data.total, filesInProgress: data.inProgress })
      );
    }
  }, [data, location, newFiles, totalFiles, isExportsFlowExist]);
};
